import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

const TextFieldGroup = ({
  field,
  value,
  label,
  id,
  error,
  type,
  onChange,
  checkUserExists,
  placeholder,
  disabled,
  classValue
}) => {
  return (
    <div className={classnames({ "has-error": error })}>
      <label className="control-label">{label}</label>
      <input
        value={value}
        onChange={onChange}
        onBlur={checkUserExists}
        type={type}
        name={field}
        id={id}
        disabled={disabled}
        className={classnames("form-control", classValue)}
        placeholder={placeholder}
      />
      {error && <span className="error-color">{error}</span>}
    </div>
  );
};

TextFieldGroup.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checkUserExists: PropTypes.func,
  classValue: PropTypes.string
};

TextFieldGroup.defaultProps = {
  type: "text"
};

export default TextFieldGroup;



// WEBPACK FOOTER //
// ./src/reusable/TextFieldGroup.js